import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowUpRight } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/website-optimization", label: "Services" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/blog", label: "Blog & Resources" },
];

export default function NotFoundPage() {
  return (
    <main
      data-testid="notfound-page"
      className="grain flex min-h-[70vh] items-center bg-white"
    >
      <Helmet>
        <title>Page Not Found — ZD Design</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="mx-auto max-w-3xl px-4 py-32 text-center sm:px-8">
        <p className="font-mono text-[13px] font-semibold uppercase tracking-[0.2em] text-flame">
          404 — Page not found
        </p>
        <h1 className="mt-5 font-display text-5xl font-extrabold tracking-tight text-slate-900 sm:text-6xl">
          This link took a wrong turn.
        </h1>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-slate-800">
          The page you're after doesn't exist — but everything we do is one
          click away. Try one of these:
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`notfound-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="inline-flex items-center gap-1.5 rounded-2xl border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-900 transition-colors hover:border-flame hover:text-flame"
            >
              {l.label}
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          ))}
        </div>
        <p className="mt-10 text-base text-faint">
          Looking for something else? Try the links above, or head back{" "}
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="font-semibold text-flame underline underline-offset-4 hover:text-ember"
          >
            to the home page
          </Link>
          .
        </p>
      </div>
    </main>
  );
}
